import React from 'react';
import SearchBar from '../../searchbar/SearchBar';
import FieldSet from '../../fieldset/FieldSet';
import Grid from '../../grid/Grid';
import UtilitiesService from '../../../service/UtilitiesService';
import { EMPTY_GRID_DEFAULT_MESSAGE, } from '../../../modules/Constants';

class BeaufortUnenrollment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      headers: [],
      rows: [],
    };

    this.comboFields = [
      {
        value: 'Date',
        display: 'Unenrollment Date',
      },
    ];
  }

  onClick(event) {
    this.reset();
    const rows = [];
    let headers = [];
    UtilitiesService.getBeaufortUnenrollmentsByDate(event.search.value)
      .then((response) => {
        console.log(response.data.unenrollments);
        if (response.data.unenrollments.length > 0) {
          headers = [ {
            display: 'Customer Id',
          },
          {
            display: 'Ebilling Ids',
          },
          {
            display: 'Account Ids',
          },
          {
            display: 'Pins',
          },
          {
            display: 'Created At',
          },
          {
            display: 'Sent',
          },
          ];
          response.data.unenrollments.forEach((unenrollment) => {
            rows.push({
              value: [
                unenrollment.customerId,
                unenrollment.ebillingIds,
                unenrollment.accountIds,
                unenrollment.pins,
                unenrollment.createdAt,
                unenrollment.sent,
              ],
            });
          });
        }
        this.setState({
          headers,
          rows,
        });
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        event.kill();
      });
  }

  reset() {
    this.setState({
      headers: [],
      rows: [],
    });
  }

  render() {
    const { headers = [], rows = [], } = this.state;
    const style = {
      maxHeight: '500px',
    };
    return (
      <div className="container">
        <SearchBar comboFields={this.comboFields} onClick={data => this.onClick(data)} />
        <div style={{ marginTop: '50px', }}>
          <FieldSet title="Pins" style={style}>
            <Grid
              headers={headers}
              rows={rows}
              onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
            />
          </FieldSet>
          {}
        </div>
      </div>
    );
  }
}

export default BeaufortUnenrollment;
